import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { setLocale, t } from "./i18n";
import "@fontsource-variable/inter";
import "@fontsource/archivo-black/latin.css";
import "./styles.css";


setLocale("en");
document.title = t("meta.title");

const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
// Pre-rendered pages are hydrated, the empty shell (app.html) is rendered (ADR-0050). A mismatch falls back
// to a client render, as before; it is only worth a console line while developing.
const root = document.getElementById("root")!;
if (root.firstElementChild) {
  hydrateRoot(root, app, {
    onRecoverableError: (error) => {
      if (import.meta.env.DEV) console.warn("hydration:", error);
    },
  });
} else {
  createRoot(root).render(app);
}
